{
    "title": "Welcome back!",
    "featureSectionTitle": "Here's what's new:",
    "features": [
        {
            "url": "https://www.nutshell.com/blog/new-shared-email-inbox",
            "text": "Shared email inbox management"
        },
        {
            "url": "https://www.nutshell.com/blog/voice-to-text-activity-logging",
            "text": "AI-powered mobile activity logging"
        },
        {
            "url": "https://www.nutshell.com/blog/catch-engaged-leads-early-with-page-based-marketing-automations",
            "text": "Page-based marketing automations"
        },
        {
            "url": "https://www.nutshell.com/blog/new-multi-page-forms",
            "text": "Multi-page form builder"
        }
    ],
    "readMore": {
        "fullText": "🌸 Read more about our spring updates",
        "linkText": "Read more",
        "url": "https://www.nutshell.com/product-updates"
    }
}
